import React from 'react'
import './Error.css'
import { NavLink } from 'react-router-dom'
const Error = () => {
  return (
    <>  
    <NavLink to="/">
      <div className="error_page"></div>
    </NavLink>
        
        
    </>
  )
}

export default Error